import { apiGet } from '../../fetch/apiService';

export const fetchTeams = datasource => {
	return apiGet('my-teams', { data_source: datasource });
};
